import React from 'react';
import { FragmentParagraphEmailSignupFormFragment } from '@/utils/drupal-api/__generated__/graphql';
import { ImageSrcSetSize } from '@/utils/image';
import clsx from 'clsx';
import { BrandConfig } from 'types/brand-config';

import DrupalImage from '@/components/ui/drupal-image';
import { EmailSignupForm } from '@/components/contact-form/email-signup-form';

const backgroundSrcsetSizes: ImageSrcSetSize[] = [
  { viewport: 420, image: 420 },
  { viewport: 640, image: 640 },
  { viewport: 1024, image: 1024 },
  { viewport: 1600, image: 1600 },
  { viewport: 2000, image: 2000 },
  { viewport: 2400, image: 2400 },
];

export type EmailSignupProps = {
  data: FragmentParagraphEmailSignupFormFragment;
  className?: string;
  brand: BrandConfig;
  id?: string;
};

export const EmailSignup: React.FC<EmailSignupProps> = ({
  data,
  className = 'mx-auto text-center',
  brand,
  id,
}) => {
  return (
    <section
      className={clsx(
        'paragraph-email-signup',
        className,
        'relative flex aspect-[4.5/1] w-screen'
      )}
      id={id}
    >
      {data.image?.__typename == 'MediaImage' && (
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <DrupalImage
            className="h-full w-full object-cover"
            aspect={4.5}
            image={data.image.mediaImage}
            srcsetSizes={backgroundSrcsetSizes}
          />
        </div>
      )}
      {data.bgColor && (
        <div
          className="absolute inset-0 -z-10"
          style={{ backgroundColor: `#${data.bgColor}` }}
        />
      )}
      <div className="relative m-auto flex max-w-3xl flex-col items-center justify-center px-4 py-12 md:py-16">
        {(data.header || data.subHeader) && (
          <div className="mb-8">
            {data.header && (
              <h2 className={`text-white drop-shadow-md`}>{data.header}</h2>
            )}
            {data.subHeader && (
              <h3 className={`ut-lg text-white drop-shadow-md`}>
                {data.subHeader}
              </h3>
            )}
          </div>
        )}
        <EmailSignupForm
          className="w-full !gap-x-2 !gap-y-4 bg-transparent !p-0 md:w-[736px] md:flex-row"
          buttonClassName="sm:w-auto"
          brandKey={brand.key}
          buttonLabel="Sign Up"
        />
      </div>
    </section>
  );
};
